<template>
<header class="tg-header" :class="{transparent:transparent}" :data-theme="theme">
	<div class="flex-container topBar tg-head"
		 :style="{transform: 'translateY('+translateY+'px)','-webkit-transform': 'translateY('+translateY+'px)'}"
		 :class="fixed ? 'topBar-fixed' : ''"
		 v-show="showStatus && !isfixed">
		<div class="header_left" style="min-width: 20%;">
			<component :is="item.name" :scp="item.scp" v-for="item in leftItems"></component>
			<!--<i class="icon-back text-center text-light"></i>-->
		</div>
		<div :class="`flex1 fs-18 text-center text-${titleColor} text-limit1`"
			 v-if="mode === 'title'"
			 @click="tgHeadTitleClick"
			 :style="{'text-indent':transparent?'-9999px':'initial'}">
			{{title}}
			<div v-if="subIcon" style="display: inline-block"><i class="icon icon-unfold"></i></div>
		</div>
		<div class="flex1 fs-18 text-center text-limit1" v-if="mode === 'slot'">
			<slot></slot>
		</div>
		<div class="text-right header_right paddingr20" style="min-width: 20%">
			<component :is="item.name" :scp="item.scp" v-for="item in rightItems"></component>
		</div>
	</div>
	<div class="flex-container topBar borderb" style="visibility: hidden;" v-if="fixed && !isfixed"></div>

	<!-- head固定的情况 -->
	<div class="flex-container topBar tg-head" style="position:fixed;top:0;width:100%;z-index:999"  v-show="showStatus && isfixed" >
		<div class="header_left" style="min-width: 20%;">
			<component :is="item.name" :scp="item.scp" v-for="item in leftItems"></component>
			<!--<i class="icon-back text-center text-light"></i>-->
		</div>
		<div :class="`flex1 fs-18 text-center text-${titleColor} text-limit1`"
			 v-if="mode==='title'"
			 @click="tgHeadTitleClick"
			 :style="{'text-indent':transparent?'-9999px':'initial'}">
			{{title}}
			<div v-if="subIcon" style="display: inline-block"><i class="icon icon-unfold"></i></div>
		</div>
		<div class="flex1 fs-18 text-center text-limit1" v-if="mode==='slot'">
			<slot></slot>
		</div>
		<div class="text-right header_right paddingr20" style="min-width: 20%">
			<component :is="item.name" :scp="item.scp" v-for="item in rightItems"></component>
		</div>
	</div>
	<div style="height:44px" v-show="showStatus && isfixed"></div>

	<div class="header_more" v-if="showMenu">
		<ul class="">
			<!--备注，这个地方使用了empty伪类，需要保持写在一行所以不要格式化代码，否则样式有问题-->
			<li class="padding20 fs-15" v-for="item in menuList"><component :is="item.name" :scp="item.scp"></component></li>
		</ul>
	</div>

</header>
</template>
<script>
import maple from 'maple';
import app from 'app';
import $ from 'jquery';
import _ from '_';
import components from '../menuItem/index.js';
let LAST_SCROLL_TOP = 0
    , HEAD_BAR_HEIGHT = 44
    , pageScp
    , rightItems
    , menuList
    ;


// 设置菜单
menuList = [{
	name: 'message'
	, scp: 'mr.noti'
}, {
	name: 'index'
	, scp: 'mr.thome'
}];

if( (maple.cookie('hybrid') && app.getTgAppVersion() < 9) || (maple.cookie('global')==='airmall')){
    menuList.push({
        name: 'shoppingCart'
		, scp: 'mr.tscar'
    });
}
if( maple.cookie('hybrid') ){
	menuList.push({
		name: 'share'
		, scp: 'mr.tshare'
	});
}

// 右边菜单
rightItems = [{
    name: 'shoppingCart'
    , scp: 'mr.tscar'
}];
if( menuList.length ){
	rightItems.push({
		name: 'menuControl'
	});
}

export default {
    ready:function(){
		var _this=this
			;
		app.constructor.headerMenuEvent=function(){
			_this.showMenu=!_this.showMenu
		};
	    this.contactApp && maple.cookie('hybrid') && app.setTgTitle(this.title);
		document.title = this.title;

		maple.cookie('hybrid') !== 'true' && $(document).on('scroll', function(event) {

			event.preventDefault();

			var scT = document.body.scrollTop;

			/*需要在图文详情页取消掉炫酷的效果*/
			if( scT > LAST_SCROLL_TOP ){    // 向下滚动
				if( scT > HEAD_BAR_HEIGHT ){
					if( _this.translateY > 0 ){
						_this.translateY = Math.max(_this.translateY - (scT - LAST_SCROLL_TOP), 0);
					}
					_this.fixed = true;
				}
				else{
					_this.translateY = 0;
					_this.fixed = false;
				}
			}
			else if( scT === 0 ){   // 滚到顶部
				_this.translateY = 0;
				_this.fixed = false;
			}
			else{   // 向上滚动
				_this.fixed = true;
				_this.translateY = Math.min(_this.translateY + (LAST_SCROLL_TOP - scT), 44);
			}

			LAST_SCROLL_TOP = scT;

			_this.showMenu=false;
		}).on('click', function(event) {
			_this.showMenu=false;
		});
	},
	props:{
		title:{
			type:String,
			default:'【大商天狗】大商集团电商平台'
		},
		titleColor:{
			type:String,
			default:'green'
		},
		target:Object,
        leftItems: {
            type: Array
            , default: [{
                name: 'back',
                scp:'back.0'
            }]
        }
        , rightItems: {
            type: Array
            , default: rightItems
        }
        , menuList: {
            type: Array
            , default: menuList
        }
        , shareInfo:{
        	type:Object,
        	default:{}
        }
        , transparent:{
        	type:Boolean,
        	default:false
        }
        , subIcon:{
        	type:Boolean,
        	default:false
        }
        , contactApp: {	// 是否与 app 交互
			type: Boolean
			, default: true
		}
		, isfixed: {	// 是否固定在顶端
			type: Boolean
			, default: false
		}
		, mode: {
			type: String
			, default: 'title'
		}
		, theme: {
			type: String
			, default: ''
		}
	},
	data:function(){
		return {
            showStatus:!maple.cookie('hybrid'),
			fixed: false,
			translateY: 0,
			showMenu:false
		}
	}
	, components: components
    , events: {
        toggleMenu: function(){
            this.$set('showMenu', !this.showMenu);
        }
        , shareControl: function(){
            this.showMenu = false;
        	this.shareInfo=_.defaults((Object.keys(this.shareInfo).length?this.shareInfo:(this.$root.wcShareInfo||this.$root.shareInfo||{})),{
        		title: '【大商天狗】大商集团电商平台', // 分享标题
        		subTitle: 'm.51tiangou.com', // 分享描述
        		friendTitle: '【大商天狗】大商集团电商平台',
        		imageUrl    : 'http://image1.51tiangou.com/tgou2/img2/tgou_logo4.png',
        		url         : location.href
        	})

			if( !/^https?:/.test( this.shareInfo.imageUrl ) ){
        		this.shareInfo.imageUrl = 'http:'+ this.shareInfo.imageUrl;
			}

        	this.shareInfo.imgUrl=this.shareInfo.imageUrl;

			if( this.shareInfo.link ){
				// 为 App 分享设置协议头
				if( /^http:/.test(this.shareInfo.link) ){
					this.shareInfo.link.replace(/^http:/, location.protocol);
				}
				else if( /^\/\/:/.test( this.shareInfo.link ) ){
					this.shareInfo.link = location.protocol + this.shareInfo.link;
				}

				this.shareInfo.url = this.shareInfo.link;
			}

			try{
				/**
				 * 2017-11-28 周文博
				 * 替换分享 APP 方法
				 * */
				app.share( this.shareInfo );

//				//版本判断
//				if( app.getTgAppVersion() < 3 ){
//					//版本<3
//					window.app.share(this.shareInfo.friendTitle, this.shareInfo.subTitle, this.shareInfo.imageUrl, this.shareInfo.url); //分享
//				}else{
//					//版本≥3
//					window.app.share(JSON.stringify(this.shareInfo));
//				}

			}
            catch(e){
                console.log(e);
            }
        }
    }
    , watch: {
		showMenu: function(){
			this.$dispatch('headerMenu');
		}
		, title: function(newTitle){
			this.contactApp && maple.cookie('hybrid') && app.setTgTitle(newTitle);
		}
	}
	, methods:{
		tgHeadTitleClick:function(){
			this.$dispatch('tgHeadTitleClick')
		}
	}
}
</script>
<style lang="scss">
@import './style.css';

.tg-header.transparent .topBar{
	background-color:transparent;
	position: absolute;
	width:100%;
	top:0;
	border-bottom: none;
}
.header_more a{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex !important;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;

    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start
}
.header_more ul li:empty{display: none}
.header_more a span{
	line-height: 20px;
	display:inline-block;
}
</style>
